module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/video-poster-2-06b00091692032eca25a015dc8b35569.jpg";